// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.verify-panel[data-v-1cce283a] { width: 520px; padding: 24px 0;\n}.toolbar[data-v-1cce283a] { display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-align: center; -ms-flex-align: center; align-items: center; gap: 10px; margin-bottom: 16px;\n}.toolbar .el-input[data-v-1cce283a] { width: 240px;\n}.danger[data-v-1cce283a] { color: #f56c6c;\n}.el-pagination[data-v-1cce283a] { margin-top: 16px; text-align: right;\n}\r\n", ""]);
// Exports
module.exports = exports;
